module.exports = __webpack_public_path__ + "img/near.2f84d8ca.png";